// import one from '../assets/jpg/landingPage.jpg'
import two from '../assets/svg/projects/two.svg'
import three from '../assets/svg/projects/three.svg'
import four from '../assets/svg/projects/four.svg'
import five from '../assets/svg/projects/five.svg'
import six from '../assets/svg/projects/six.svg'
import seven from '../assets/svg/projects/seven.svg'
import eight from '../assets/svg/projects/eight.svg'


export const projectsData = [
    
    {
        id: 1,
        projectName: 'PARCAR',
        projectDesc: "Parking management application showing live, the number of free spaces per slots developed for owners of parking lots",
        tags: ['React Js','HTML', 'CSS', 'JavaScript'],
        code: 'https://github.com/SubhamGupta007/Parcar',
        demo: 'https://parcar.netlify.app/',
        image: 'https://i.ibb.co/gmCXVPY/Screenshot-72.png'
    },
    {
        id: 2,
        projectName: 'REALTOR',
        projectDesc: 'Real estate web application for searching property , buying or renting',
        tags: ['React Js','REDUX','HTML','Chalra UI','API'],
        code: 'https://github.com/SubhamGupta007/Realestata',
        demo: 'https://realestata.vercel.app/',
        image: 'https://i.ibb.co/48zzxqP/Screenshot-74.png'
    },
    {
        id: 3,
        projectName: 'RAAHAT.rx',
        projectDesc: 'Consulting web application for Diabetic patients',
        tags: ['API', 'JavaScript', 'HTML', 'CSS','Agoda'],
        code: 'https://github.com/SubhamGupta007/Raahat',
        demo: 'https://raahat.herokuapp.com/',
        image: 'https://i.ibb.co/C9hZWVN/Weather-app.png'
    },
   
]


// Do not remove any fields.
// Leave it blank instead as shown below

/* 
{
    id: 1,
    projectName: 'Car Pooling System',
    projectDesc: '',
    tags: ['Flutter', 'React'],
    code: '',
    demo: '',
    image: ''
}, 
*/